export default __webpack_public_path__ + "static/media/notification.167cf79a.svg";